import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "uxp"
    }}>{`uxp`}</h1>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Entry%20Points/index.md"
        }}>{`Entry Points`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Host%20Information/index.md"
        }}>{`Host Information`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Key-Value%20Storage/index.md"
        }}>{`Key-Value Storage`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Persistent%20File%20Storage/index.md"
        }}>{`Persistent File Storage`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Plugin%20Manager/index.md"
        }}>{`Plugin Manager`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "User%20Information/index.md"
        }}>{`User Information`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Versions/index.md"
        }}>{`Versions`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "XMP/getting-started/xmp.md"
        }}>{`XMP`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "shell/index.md"
        }}>{`shell`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      